import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class DraftPlanHeaderReferenceService extends BaseReferenceService {
  constructor() {
    super('DraftPlanHeaderReference');
  }
}
